import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Typography from 'material-ui/Typography';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import Console from '../../../../lib/debug';
import CONF from '../../../../api/config';
import SuggestedSwaps from './SuggestedSwaps';
import PointsOfPerformance from './PointsOfPerformance';
import PointsOfPerformanceEmpty from './PointsOfPerformanceEmpty';
import ExerciseVideoThumbnail from './ExerciseVideoThumbnail';

function ExercisePreview({
    exercise,
    uiSaving,
    onDelete,
    videosWrapperRef,
    isInCircuitBuilder
}) {
    Console.render('designer.ExercisePreview');

    const { swapExercises, pointsOfPerformance, canEditExercise } = useSelector(
        state => {
            if (
                exercise === null ||
                exercise === undefined ||
                !exercise.exercise_id
            )
                return {
                    swapExercises: [],
                    pointsOfPerformance: '',
                    canEditExercise: false
                };
            const libraryExercise = state.library.exerciseRef.find(
                e => e.id === exercise.exercise_id
            );
            return {
                swapExercises:
                    libraryExercise && libraryExercise.swaps
                        ? libraryExercise.swaps
                        : [],
                pointsOfPerformance:
                    libraryExercise && libraryExercise.points_of_performance
                        ? libraryExercise.points_of_performance
                        : '',
                canEditExercise:
                    libraryExercise &&
                    (libraryExercise.can_edit === 1 ||
                        libraryExercise.can_edit === null)
            };
        }
    );

    const hasPointsOfPerformance = pointsOfPerformance
        .split(/\r?\n/)
        .some(point => point.trim());

    return (
        <div className="exercise-preview-container">
            <div className="exercise-preview-header">
                <div className="exercise-preview-header-actions">
                    <a
                        className="exercise-preview-library-link"
                        href={
                            exercise.exercise_id
                                ? `${
                                      CONF.BASE_URL_LIBRARY
                                  }/exercises?exerciseId=${
                                      exercise.exercise_id
                                  }`
                                : `${CONF.BASE_URL_LIBRARY}/exercises`
                        }
                        target="_blank"
                        rel="noreferrer"
                    >
                        {canEditExercise ? 'Edit Exercise' : 'Edit Swaps'}
                        <i className="mdi mdi-open-in-new exercise-preview-library-link-icon" />
                    </a>
                </div>
            </div>
            <div className="exercise-preview-body">
                {exercise.video_url ? (
                    <ExerciseVideoThumbnail
                        exercise={exercise}
                        uiSaving={uiSaving}
                        hideDelete={true}
                        onDelete={onDelete}
                        videosWrapperRef={videosWrapperRef}
                        isInCircuitBuilder={isInCircuitBuilder}
                    />
                ) : (
                    <div>
                        <div
                            style={{ width: 120, height: 78 }}
                            className="noVideo"
                        >
                            <span className="overline">No Video.</span>
                            <VideocamOffIcon className="videoIcon" />
                        </div>
                        <p>{exercise.title}</p>
                    </div>
                )}
                <div className="exercise-preview-details">
                    <SuggestedSwaps swapExercises={swapExercises} />
                    <div className="exercise-preview-divider" />
                    {hasPointsOfPerformance ? (
                        <PointsOfPerformance points={pointsOfPerformance} />
                    ) : (
                        <PointsOfPerformanceEmpty />
                    )}
                </div>
            </div>
        </div>
    );
}

export default ExercisePreview;
